<button class="btn-outline pl-3 pr-3 flex-between-center" [id]="id" [disabled]="disabled"
  [ngClass]="{'disabled': disabled, 'active': active, 'deactive': !active}" (click)="onClick()">
  <span>
    <i [class]="icon" [ngClass]="{'outline-btn-icon': true,'font-bold': active}">
      <i *ngIf="active" class="fal fa-check-circle flex-center-center check-active"></i>
    </i>
    <span class="ml-2">{{label}}</span>
  </span>

  <i class="fal fa-check-square font-gray-45" *ngIf="active"></i>
  <i class="fal fa-square font-gray-45" *ngIf="!active"></i>
</button>
